module.exports = __webpack_public_path__ + "img/it_insurama.df5aa58e.svg";